/** Brag bot: the Teen Patti strategy, which already reads the ranking from the table's config. */
import type { BotEngine } from '../../bots/types.js';
import { teenPattiBot } from '../teenpatti/bot.js';
import type { BragAction, BragLegal, BragView } from './engine.js';

export const bragBot: BotEngine<BragView, BragLegal, BragAction> = teenPattiBot as unknown as BotEngine<BragView, BragLegal, BragAction>;
